import { useIdentityStore } from '~/store/identity';

export default defineNuxtPlugin({
  name: 'allow-iframe',
  parallel: true,
  async setup(nuxtApp) {
    const route = nuxtApp.$router.currentRoute.value
    const whiteListNoIframeRoutes = [
      '/guest/additional-owner',
      '/guest/additional-owner/post-offer-docs',
      '/embedded/docusign-redirect', // DocuSign redirect handler - unauthenticated route
    ]

    const whitelisted = (route && whiteListNoIframeRoutes.includes(route.path))
    const isIframe = window.self !== window.top
    const iframeOnlyOrigin = await useIdentityStore().isIframeOnly();

    //if not whitelisted and the iframe context doesn't match the origin's iframe-only setting, block it.
    if (!whitelisted && (isIframe !== iframeOnlyOrigin)) {
      return showError({ statusCode: 404, statusMessage: 'Page not found' })
    }
  },
})
